module.exports = __webpack_public_path__ + "img/image_mulher2.9e4dc211.webp";